export default function kirinusHeader() {
  if (document.querySelector('.kirinus-header')) {
    const mediaQuery = 991;

    // Wähle alle Elemente mit der Klasse 'submenu'
    const submenus = document.querySelectorAll('.kirinus-header__submenu-third-col');
    const submenus2 = document.querySelectorAll('.kirinus-header__submenu-fourth-col');

// Wähle das Footer-Element, das kopiert werden soll
    const footer = document.querySelector('.kirinus-header__footer');

    if (footer) {
      submenus.forEach((submenu) => {
        const footerClone = footer.cloneNode(true);
        submenu.appendChild(footerClone);
      });

      submenus2.forEach((submenu) => {
        const footerClone = footer.cloneNode(true);
        submenu.appendChild(footerClone);
      });
    }

    // Aktivieren und Anzeigen des Hauptmenüs
    const menuItems = document.querySelectorAll('.kirinus-header__menu .nav-link[aria-controls]');
    if (menuItems) {
      menuItems.forEach((menuItem) => {
        menuItem.addEventListener('click', (event) => {
          event.preventDefault();

          const targetId = menuItem.getAttribute('aria-controls');
          const targetElement = document.getElementById(targetId);
          if (!targetId || !targetElement) return;

          // Alle aktiven Menüs und Submenüs deaktivieren
          document.querySelectorAll('.kirinus-header__submenu.active').forEach((submenu) => {
            submenu.classList.remove('active');

            if (window.innerWidth > mediaQuery) {
              submenu.style.display = 'none';
            } else {
              setTimeout(() => submenu.style.display = 'none', 250);
            }
          });



          // Neues Menü aktivieren
          if (menuItem.classList.contains('active')) {
            closeSubmenus();
            document.querySelector('body').classList.remove('content-is-blur');
            document.documentElement.classList.remove('menu-open-desktop');
            document.querySelector('body').classList.remove('overflow-hidden');
          } else {
            document.querySelectorAll('.kirinus-header__menu .nav-link.active').forEach((link) => {
              link.classList.remove('active');
            });

            menuItem.classList.add('active');
            // targetElement.style.display = 'block';

            if (window.innerWidth > mediaQuery) {
              targetElement.style.display = 'block';
            }

            setTimeout(() => targetElement.classList.add('active'), 10); // Transition starten

            if (window.innerWidth <= mediaQuery) {
              setTimeout(() => document.querySelector('.kirinus-header__menu').classList.add('is-move'), 10);
            }

            document.documentElement.classList.add('menu-open-desktop');
            document.querySelector('body').classList.add('overflow-hidden');
            document.querySelector('body').classList.add('content-is-blur');
          }



        });
      });
    }

    // Erste Submenü-Box aktivieren
    document.querySelectorAll('.kirinus-header .kirinus-header__submenu-box:first-of-type').forEach((box) => {
      if (!box.closest('.kirinus-header__submenu-fourth-col') || !box.closest('.kirinus-header__submenu-fourth-col')) {
        box.classList.add('active');
      }
    });

    document.querySelectorAll('.kirinus-header .kirinus-header__submenu-box:not(.active)').forEach((box) => {
      box.style.display = 'none';
    });

    // Submenü-Items
    const submenuItemsAria = document.querySelectorAll('.kirinus-header .kirinus-header__submenu-item[aria-controls]');
    const submenuItems = document.querySelectorAll('.kirinus-header .kirinus-header__submenu');
    submenuItemsAria.forEach((submenuItem) => {
      submenuItem.addEventListener('click', (event) => {
        event.preventDefault();

        const targetId = submenuItem.getAttribute('aria-controls');
        if (!targetId) return;
          let body = document.querySelector('body');

          //toggle menu
          if (submenuItem.classList.contains('active') && window.innerWidth > mediaQuery) {
            // Aktive Submenüs deaktivieren
            submenuItem.closest('.kirinus-header__submenu').querySelectorAll('.kirinus-header__submenu-box').forEach((box) => {
              box.classList.remove('active');

              if (window.innerWidth > mediaQuery) {
                box.style.display = 'none';
              }
            });

            // Ziel-Elemente aktivieren
            submenuItem.closest('.kirinus-header__submenu').querySelectorAll(`[data-header-box-id="${body.getAttribute('data-header-submenu')}"]`).forEach((box) => {
              box.style.display = 'block';

              setTimeout(() => box.classList.add('active'), 10); // Transition starten

              box.closest('.kirinus-header__submenu').classList.remove('kirinus-header__submenu-relative');
            });
            body.removeAttribute('data-header-submenu');
            submenuItem.classList.remove('active')
          } else {
            body.setAttribute('data-header-submenu', submenuItem.closest('.kirinus-header__submenu').querySelector('.kirinus-header__submenu-box.active').getAttribute('data-header-box-id'));

            // Aktive Submenüs deaktivieren
            submenuItem.closest('.kirinus-header__submenu').querySelectorAll('.kirinus-header__submenu-box').forEach((box) => {
              box.classList.remove('active');

              if (window.innerWidth > mediaQuery) {
                if (!box.querySelector('.kirinus-header__submenu-big')) {
                  box.style.display = 'none';
                }

                if (box.querySelector('.kirinus-header__submenu-first-col ul')) {
                  box.style.display = 'block';
                }
              }
            });

            // Neues Submenü aktivieren (Desktop)
            if (submenuItem.closest('.kirinus-header__submenu-big') && window.innerWidth > mediaQuery || submenuItem.closest('.kirinus-header__submenu-first-col') && window.innerWidth > mediaQuery) {
              submenuItem.closest('.kirinus-header__submenu-box').classList.add('active');
            }

            if (submenuItem.closest('ul') && window.innerWidth <= mediaQuery) {
              submenuItem.closest('.kirinus-header__submenu').classList.add('move-1-3');

              setTimeout(() => submenuItem.closest('.kirinus-header__submenu').classList.add('start'), 10);
              setTimeout(() => submenuItem.closest('.kirinus-header__submenu').classList.add('finish'), 250);
            }

            // Neues Submenü aktivieren (Mobile)
            // if (window.innerWidth <= mediaQuery) {
            //   submenuItem.closest('.kirinus-header__submenu').querySelector('.kirinus-header__submenu-second-col').classList.add('active');
            // }

            // Ziel-Elemente aktivieren
            submenuItem.closest('.kirinus-header__submenu').querySelectorAll(`[data-header-box-id="${targetId}"]`).forEach((box) => {
              box.style.display = 'block';

              setTimeout(() => box.classList.add('active'), 10); // Transition starten

              setTimeout(function (){
                if (box.closest('.kirinus-header__submenu-fourth-col') && window.innerWidth > mediaQuery) {
                  box.closest('.kirinus-header__submenu').classList.add('kirinus-header__submenu-relative');
                }
              }, 10);


              // box.classList.add('active');
            });

            if(submenuItem.closest('.kirinus-header__submenu-big')) {
              if(submenuItem.closest('.kirinus-header__submenu-big').querySelector('.kirinus-header__submenu-item.active') !== null) {
                submenuItem.closest('.kirinus-header__submenu-big').querySelector('.kirinus-header__submenu-item.active').classList.remove('active');
              }
            }

            if (submenuItem.closest('ul').querySelector('.kirinus-header__submenu-item.active')) {
              submenuItem.closest('ul').querySelector('.kirinus-header__submenu-item.active').classList.remove('active');
            }

            submenuItem.classList.add('active');

            // „Back to“-Button aktualisieren
            submenuItem.closest('.kirinus-header__submenu').querySelector('.btn--back').setAttribute('aria-controls', targetId);
          }
      });
    });

    // Dynamische Breite für Submenü-Links
    if (document.querySelector('.kirinus-header__submenu-first-col')) {
      for (const item of submenuItems) {
        let maxWidth = 0;

        if (item.querySelector('.kirinus-header__submenu-first-col')) {
          for (const menuItem of item.querySelector('.kirinus-header__submenu-first-col').querySelectorAll('.kirinus-header__submenu-item')) {
            let itemWidth = menuItem.offsetWidth;
            if (itemWidth > maxWidth) {
              maxWidth = itemWidth;
            }
          }
        }

        for (const menuItem of item.querySelectorAll('.kirinus-header__submenu-item[aria-controls]')) {
          menuItem.style.setProperty(`--max-link-width`, `${maxWidth + 34}px`);
        }
      }
    }

    // „Back to“-Button
    const backButtons = document.querySelectorAll('.kirinus-header .btn--back');
    if (backButtons) {
      backButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          const targetId = button.getAttribute('aria-controls');
          if (!targetId) {
            if(button.closest('.kirinus-header__submenu').querySelector('.kirinus-header__submenu-first-col .kirinus-header__submenu-box:first-of-type').classList.contains('active')) {
              button.closest('.kirinus-header__submenu').classList.remove('active')
            }

            if(!button.closest('.kirinus-header__submenu').classList.contains('move-1-3')) {
              document.querySelector('.kirinus-header__menu').classList.remove('is-move')
            }

            menuItems.forEach((element) => {
              if (element.classList.contains('active')) {
                element.classList.remove('active');
              }
            });
          } else {
            // Aktive Submenüs deaktivieren
            document.querySelectorAll(`[data-header-box-id="${targetId}"]`).forEach((box) => {
              if(button.closest('.kirinus-header__submenu').classList.contains('move-1-3')) {
                setTimeout(() => box.classList.remove('active'), 250);
                setTimeout(() => box.style.display = 'none', 250);
              } else {
                box.classList.remove('active');
                box.style.display = 'none';
              }
            });

            // Erste Submenü-Box wieder aktivieren
            const firstCol = button.closest('.kirinus-header__submenu').querySelector('.kirinus-header__submenu-first-col');
            const secondCol = button.closest('.kirinus-header__submenu').querySelector('.kirinus-header__submenu-second-col');
            const thirdCol = button.closest('.kirinus-header__submenu').querySelector('.kirinus-header__submenu-third-col');

            if (firstCol) {
              if (firstCol.querySelector('.kirinus-header__submenu-box:first-of-type').classList.contains('active')) {
                firstCol.closest('.kirinus-header__submenu').classList.remove('active');
              }

              firstCol.querySelectorAll('.kirinus-header__submenu-box').forEach((box) => box.classList.remove('active'));
              firstCol.querySelector('.kirinus-header__submenu-box:first-of-type').classList.add('active');
            }

            if (secondCol) {
              secondCol.classList.remove('active');
              secondCol.querySelectorAll('.kirinus-header__submenu-box').forEach((box) => box.classList.remove('active'));
              secondCol.querySelector('.kirinus-header__submenu-box:first-of-type').classList.add('active');
            }

            if (thirdCol) {
              thirdCol.querySelectorAll('.kirinus-header__submenu-box').forEach((box) => box.classList.remove('active'));
              thirdCol.querySelector('.kirinus-header__submenu-box:first-of-type').classList.add('active');
            }

            button.closest('.kirinus-header__submenu').querySelector('.kirinus-header__submenu-fourth-col').style.top = '39px';
            button.closest('.kirinus-header__submenu').classList.remove('finish');
            setTimeout(() => button.closest('.kirinus-header__submenu').classList.remove('start'), 10);

            setTimeout(() => button.closest('.kirinus-header__submenu').querySelector('.kirinus-header__submenu-fourth-col').style.top = '', 250);
            setTimeout(() => button.closest('.kirinus-header__submenu').classList.remove('move-1-3'), 250);

            const menuItems = document.querySelectorAll('.kirinus-header__menu .nav-link');

            menuItems.forEach((element) => {
              if (element.classList.contains('active')) {
                element.classList.remove('active');
              }
            });

            if(!button.closest('.kirinus-header__submenu').classList.contains('move-1-3')) {
              document.querySelector('.kirinus-header__menu').classList.remove('is-move')
            }
          }
        });
      });
    }


    // Zusätzliche Anpassungen für Submenüs
    document.querySelectorAll('.kirinus-header .kirinus-header__submenu').forEach((submenu) => {
      submenu.classList.add('kirinus-header__submenu-arrow-pos-finish');
    });

    document.querySelector('.navbar-toggler').addEventListener('click', function() {
      if(this.getAttribute('aria-expanded') === 'false') {
        closeSubmenus();
        document.querySelector('body').classList.remove('overflow-hidden');
        document.querySelector('body').classList.remove('content-is-blur');
      } else {
        document.querySelector('body').classList.add('overflow-hidden');
        document.querySelector('body').classList.add('content-is-blur');
      }
    });


    function closeSubmenus() {
      const activeElements = document.querySelectorAll('.kirinus-header__submenu');
      const menuItems = document.querySelectorAll('.kirinus-header__menu .nav-link');

      if(document.querySelector('.kirinus-header__menu')) {
        activeElements.forEach((element) => {
          element.classList.remove('active');
          element.classList.remove('move-1-3');
          element.classList.remove('start');
          element.classList.remove('finish');
          element.style.display = '';

          document.querySelectorAll('.kirinus-header__submenu').forEach((element) => {
            element.classList.remove('kirinus-header__submenu-relative');
          });

          document.querySelectorAll('.kirinus-header__submenu-box').forEach((element) => {
            element.classList.remove('active');
            element.style.display = 'none';
          });

          document.querySelectorAll('.kirinus-header__submenu-item').forEach((element) => {
            element.classList.remove('active');
          });

          for (let item of (document.querySelectorAll('.kirinus-header__submenu'))) {
            let firstActiveElement =  item.querySelector('.kirinus-header__submenu-first-col .kirinus-header__submenu-box:first-of-type');
            let secondActiveElement =  item.querySelector('.kirinus-header__submenu-second-col .kirinus-header__submenu-box:first-of-type');
            let thirdActiveElement =  item.querySelector('.kirinus-header__submenu-third-col .kirinus-header__submenu-box:first-of-type');

            if(firstActiveElement) {
              item.querySelector('.kirinus-header__submenu-first-col .kirinus-header__submenu-box:first-of-type').classList.add('active');
              item.querySelector('.kirinus-header__submenu-first-col .kirinus-header__submenu-box:first-of-type').style.display = '';
            }

            if(secondActiveElement) {
              item.querySelector('.kirinus-header__submenu-second-col .kirinus-header__submenu-box:first-of-type').classList.add('active');
              item.querySelector('.kirinus-header__submenu-second-col .kirinus-header__submenu-box:first-of-type').style.display = '';
            }

            if(thirdActiveElement) {
              item.querySelector('.kirinus-header__submenu-third-col .kirinus-header__submenu-box:first-of-type').classList.add('active');
              item.querySelector('.kirinus-header__submenu-third-col .kirinus-header__submenu-box:first-of-type').style.display = '';
            }
          }


          // if (window.innerWidth <= mediaQuery) {
          //   if(document.querySelector('.navbar-toggler').getAttribute('aria-expanded') === 'true') {
          //     document.querySelector('.navbar-toggler').click();
          //   }
          // }
        });

        menuItems.forEach((element) => {
          if (element.classList.contains('active')) {
            element.classList.remove('active');
          }
        });

        document.querySelector('.kirinus-header__menu').classList.remove('is-move')
      }
    }

    // Menü schließen, wenn man außerhalb des Menü klickt
    document.addEventListener('click', function(event) {
      if (window.innerWidth > mediaQuery) {
        if (event.target.closest('.kirinus-header') === null) {
          closeSubmenus();
          document.querySelector('body').classList.remove('overflow-hidden');
          document.querySelector('body').classList.remove('content-is-blur');
        }
      } else {
        if (event.target.closest('.kirinus-header') === null) {
          if(document.querySelector('.navbar-toggler').getAttribute('aria-expanded') === 'true') {
            document.querySelector('.navbar-toggler').click();
          }
        }
      }
    });

    window.addEventListener("resize", function () {

      if (window.innerWidth > mediaQuery) {
        document.querySelector('.kirinus-header__menu').classList.remove('is-move');

        if(document.querySelector('.navbar-toggler').getAttribute('aria-expanded') === 'true') {
          document.querySelector('body').classList.remove('overflow-hidden');
          document.querySelector('body').classList.remove('content-is-blur');
        }
      }

      // if (window.innerWidth < mediaQuery) {
      //   if (document.documentElement.classList.contains('menu-open-desktop')) {
      //     document.documentElement.classList.remove('menu-open-desktop')
      //     closeSubmenus();
      //   }
      // }

    });

    function setVh() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh-header-menu', `${vh}px`);
    }
    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);
    setVh();
  }
}
